export let data = {
  "Case IHC": {
      "323": {
          "1971-1975": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "353": {
          "1971-1975": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "423": {
          "1971-1975": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "453": {
          "1971-1975": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "633": {
          "1971-1975": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "644": {
          "1974-1981": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "744": {
          "1974-1981": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "946": {
          "1971-1975": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "955": {
          "1975-1983": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1046": {
          "1971-1975": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "1055": {
          "1975-1983": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1246": {
          "1971-1975": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "1056XL": {
          "1982-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "1985-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "1255XL": {
          "1979-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "1985-1994": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "1455XL": {
          "1981-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "1985-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "385XL": {
          "1985-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "395XL": {
          "1990-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "485XL": {
          "1985-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "495XL": {
          "1990-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "585XL": {
          "1985-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "595XL": {
          "1990-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "685XL": {
          "1985-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "695XL": {
          "1990-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "743XL": {
          "1981-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "1985-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "745XL": {
          "1981-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "1985-1994": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "785XL": {
          "1985-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "795XL": {
          "1990-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "844(S)": {
          "1974-1981": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "844XL": {
          "1981-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "1985-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "845XL": {
          "1981-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "1987-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "856XL": {
          "1985-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "885XL": {
          "1985-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "895XL": {
          "1990-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "956XL": {
          "1981-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "1985-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "985XL": {
          "1989-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "995XL": {
          "1990-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "CS 100Pro": {
          "2007-2008": {
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 105Pro": {
          "2008-2011": {
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 110": {
          "1997-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "CS 120": {
          "1997-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "CS 130": {
          "1997-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "CS 150": {
          "1997-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "CS 48": {
          "1996-2001": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 52": {
          "2001-2004": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 58": {
          "1996-2001": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 63": {
          "2001-2004": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 68": {
          "1994-2004": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 75": {
          "1994-2004": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 78": {
          "1994-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 80Pro": {
          "2007-2008": {
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "CS 85Pro": {
          "2008-2011": {
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "CS 86": {
          "1995-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 90Pro": {
          "2007-2008": {
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "CS 94": {
          "1994-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CS 95Pro": {
          "2008-2011": {
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "CVX 1135": {
          "2003-2007": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 1145": {
          "2003-2007": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 1155": {
          "2003-2007": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 1170": {
          "2003-2007": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 1190": {
          "2003-2005": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 1195": {
          "2005-2007": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 120": {
          "2000-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 130": {
          "2000-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 140": {
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 150": {
          "2000-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 160": {
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 170": {
          "2000-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 175": {
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CVX 195": {
          "2007-2009": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CX100": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CX50": {
          "1998-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CX60": {
          "1998-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CX70": {
          "1998-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CX80": {
          "1998-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "CX90": {
          "1998-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 100A": {
          "2022-Present": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 100CL Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 100N Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 100V Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 105A": {
          "2012-2014": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 105CEP": {
          "2013-2021": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 105U": {
          "2012-2016": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 105UPro": {
          "2013-2016": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 110CL Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 110N Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 110U": {
          "2011-2012": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 110V Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 115A": {
          "2012-2014": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 115CEP": {
          "2013-2023": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 115U": {
          "2012-2016": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 115UPro": {
          "2013-2016": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 120CL Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 120N Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 120V Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 65A": {
          "2012-2014": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 75A": {
          "2012-2014": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 80CL Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 80N Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 80V Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 85A": {
          "2012-2014": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 85CEP": {
          "2013-2021": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 90CL Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 90N Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 90U": {
          "2011-2012": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 90V Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Farmall 95A": {
          "2012-2014": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 95CEP": {
          "2013-2021": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 95U": {
          "2012-2016": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Farmall 95UPro": {
          "2013-2016": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 100U": {
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              }
          }
      },
      "JX 1060C": {
          "2004-2008": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 1070C": {
          "2004-2008": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 1070U": {
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              }
          }
      },
      "JX 1075C": {
          "2004-2008": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 1080U": {
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              }
          }
      },
      "JX 1085C": {
          "2005-2008": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 1090U": {
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 1095C": {
          "2005-2008": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 1100U": {
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 55": {
          "2002-2006": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 60": {
          "2007-2012": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 65": {
          "2002-2006": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 70": {
          "2007-2012": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 70U": {
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 75": {
          "2002-2006": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 80": {
          "2007-2012": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 80U": {
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              }
          }
      },
      "JX 85": {
          "2002-2006": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "JX 90": {
          "2007-2012": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "JX 90U": {
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JX 95": {
          "2002-2006": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JXU 105": {
          "2008-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JXU 115": {
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JXU 75": {
          "2008-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JXU 85": {
          "2008-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "JXU 95": {
          "2008-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Luxxum 100": {
          "2016-2024": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "Luxxum 110": {
          "2016-2024": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "Luxxum 120": {
          "2016-2024": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "Magnum 225": {
          "2005-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 235": {
          "2011-2014": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 250": {
          "2005-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2014-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "Magnum 260": {
          "2011-2014": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 280": {
          "2005-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2014-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "Magnum 290": {
          "2011-2014": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 310": {
          "2005-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          },
          "2014-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "Magnum 315": {
          "2011-2014": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              }
          }
      },
      "Magnum 335": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              }
          }
      },
      "Magnum 340": {
          "2011-2014": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              }
          },
          "2014-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "Magnum 370": {
          "2012-2014": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              }
          }
      },
      "Magnum 380": {
          "2014-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "Magnum 7110": {
          "1988-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 7120": {
          "1988-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 7130": {
          "1988-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 7140": {
          "1988-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 7210": {
          "1994-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 7220": {
          "1994-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 7230": {
          "1994-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 7240": {
          "1994-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum 7250": {
          "1994-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum MX210": {
          "2002-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum MX230": {
          "2002-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum MX255": {
          "2002-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum MX285": {
          "2002-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum Pro7210": {
          "1997-1999": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum Pro7220": {
          "1997-1999": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum Pro7230": {
          "1997-1999": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum Pro7240": {
          "1997-1999": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Magnum Pro7250": {
          "1997-1999": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum  115": {
          "2018-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Maxxum  125": {
          "2018-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Maxxum  135": {
          "2018-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Maxxum  145": {
          "2018-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Maxxum  150": {
          "2018-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Maxxum 110EP": {
          "2012-2016": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 110MC": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 115CVX": {
          "2016-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "Maxxum 115EP": {
          "2012-2016": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 115MC": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 120EP": {
          "2012-2016": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 120MC": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 125CVX": {
          "2016-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "Maxxum 125EP": {
          "2012-2016": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              }
          }
      },
      "Maxxum 125MC": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 130EP": {
          "2012-2016": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 130MC": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 135CVX": {
          "2015-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "Maxxum 140EP": {
          "2012-2016": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 140MC": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 145CVX": {
          "2015-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "Maxxum 150CVX": {
          "2015-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "Maxxum 5120": {
          "1990-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 5130": {
          "1990-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 5140": {
          "1990-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum 5150": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MX100": {
          "1997-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MX100C": {
          "1998-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MX110": {
          "1997-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MX120": {
          "1997-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MX135": {
          "1997-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MX150": {
          "1998-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MX170": {
          "1998-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MX80C": {
          "1998-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MX90C": {
          "1998-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXM120": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXM140": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXM155": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXM175": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXM190": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXU100": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXU100Xline": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXU110": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXU110Xline": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXU115": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXU115Xline": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXU125": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum MXU135": {
          "2003-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum Pro5120": {
          "1996-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum Pro5130": {
          "1996-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum Pro5140": {
          "1996-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Maxxum Pro5150": {
          "1996-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Optum 250CVX": {
          "2018-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Optum 270CVX": {
          "2015-2019": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          },
          "2018-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Optum 300CVX": {
          "2015-2019": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          },
          "2018-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Optum 340CVX": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "puma 125": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "puma 130EP": {
          "2011-2015": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "puma 140": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 140": {
          "2020-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "puma 145EP": {
          "2011-2015": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "puma 150": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 150": {
          "2020-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "puma 155": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 165": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2020-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Puma 175": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2020-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Puma 180": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 185": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2021-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Puma 185EP": {
          "2011-2015": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 195": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 200": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2021-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Puma 200EP": {
          "2011-2015": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 210": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 215EP": {
          "2011-2015": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 220": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2021-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Puma 225": {
          "2009-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 230EP": {
          "2011-2015": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma 240": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2021-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Puma 260": {
          "2021-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Puma160EP": {
          "2011-2015": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Puma170EP": {
          "2011-2015": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Quantum  100CL Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  100N Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  100V Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  110CL Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  110N Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  110V Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  120CL Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  120N Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  120V Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  80CL Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  80N Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  80V Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  90CL Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  90N Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum  90V Next Gen": {
          "2023-Present": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Quantum65C": {
          "2008-2017": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Quantum75C": {
          "2008-2017": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Quantum85C": {
          "2008-2017": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Quantum95C": {
          "2008-2017": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Vestrum 100": {
          "2021-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Vestrum 110": {
          "2021-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Vestrum 120": {
          "2021-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      },
      "Vestrum 130": {
          "2021-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          }
      }
  },
  "Claas": {
      "Ares 546RX": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 547": {
          "2005-2009": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 556RX": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 557": {
          "2005-2009": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 566RX": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 567": {
          "2005-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 577": {
          "2005-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 616RZ": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 617": {
          "2005-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 656RZ": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 657": {
          "2005-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 696RZ": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 697": {
          "2005-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 816RZ": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 826RZ": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Ares 836RZ": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Arion 410": {
          "2009-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2014-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 420": {
          "2009-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2014-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 430": {
          "2009-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2014-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 440": {
          "2014-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 450": {
          "2014-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 460": {
          "2014-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 470": {
          "2021-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 510": {
          "2007-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 520": {
          "2007-2012": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Arion 530": {
          "2007-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2012-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          },
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 540": {
          "2007-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2012-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Arion 550": {
          "2012-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          },
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 610": {
          "2007-2012": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Arion 610C": {
          "2007-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Arion 620": {
          "2007-2012": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2012-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 620C": {
          "2007-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Arion 630": {
          "2007-2012": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2012-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 630C": {
          "2007-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Arion 640": {
          "2007-2012": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2012-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 650": {
          "2012-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Arion 660": {
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Atos 220": {
          "2014-2018": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Atos 230": {
          "2014-2018": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Atos 240": {
          "2014-2018": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Atos 330": {
          "2014-2018": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Atos 340": {
          "2014-2018": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Atos 350": {
          "2014-2018": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  800": {
          "2014-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Axion  810": {
          "2006-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2013-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  820": {
          "2006-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2014-2016": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  830": {
          "2006-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2013-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  840": {
          "2006-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2013-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  850": {
          "2006-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2013-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  870": {
          "2016-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  920": {
          "2011-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  930": {
          "2011-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  940": {
          "2011-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  950": {
          "2011-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axion  960": {
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Axos 310": {
          "2008-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2023-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Axos 320": {
          "2008-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Axos 330": {
          "2008-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Axos 340": {
          "2008-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Celtis 426": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          },
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Celtis 436": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Celtis 446": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Celtis 456": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Elios 210": {
          "2009-2014": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2011-2016": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2015-2022": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2019-2023": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2023-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "Elios 220": {
          "2009-2014": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2015-2022": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Elios 230": {
          "2009-2014": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2015-2022": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Elios 320": {
          "2023-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "Nexos 210": {
          "2016-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Nexos 220": {
          "2011-2016": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2016-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2022-Present": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Nexos 230": {
          "2011-2016": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2016-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Nexos 240": {
          "2011-2016": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2016-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2022-Present": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Nexos 250": {
          "2016-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Nexos 260": {
          "2022-Present": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Xerion 3300": {
          "2004-2012": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Xerion 3800": {
          "2007-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Xerion 4000": {
          "2014-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Xerion 4500": {
          "2009-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2014-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      },
      "Xerion 5000": {
          "2009-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          },
          "2014-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "adapter-cable-deutsch-dt-2-pin-za2016": {
                  
              }
          }
      }
  },
  "Deutz-Fahr": {
      "5100": {
          "2013-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5110": {
          "2013-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5120": {
          "2013-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5130": {
          "2013-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6155": {
          "2017-2023": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6160": {
          "2022-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6165": {
          "2017-2023": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6170": {
          "2022-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6175": {
          "2017-2023": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6180": {
          "2022-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6185": {
          "2017-2024": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6190": {
          "2022-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6205": {
          "2017-2023": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6210": {
          "2022-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6215": {
          "2017-2023": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6230": {
          "2022-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "7250": {
          "2020-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "8280": {
          "2022-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "9340": {
          "2022-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      " 6155.4": {
          "2017-2023": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      " 6165.4": {
          "2017-2023": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      " 6175.4": {
          "2017-2023": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "5 series D": {
          "2014-2019": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              }
          }
      },
      "5 series g": {
          "2014-2019": {
          }
      },
      "5060D Ecoline": {
          "2014-2019": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5070D Ecoline": {
          "2014-2019": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5080D Ecoline": {
          "2014-2019": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5085D Ecoline": {
          "2014-2019": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5090.4D": {
          "2014-2019": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              }
          }
      },
      "5090.4D Ecoline": {
          "2014-2019": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5090.4G": {
          "2014-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5090C": {
          "2014-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5090D": {
          "2014-2019": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5090D Ecoline": {
          "2014-2019": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5090G": {
          "2014-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5100.4D": {
          "2014-2019": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              }
          }
      },
      "5100C": {
          "2014-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5100G": {
          "2014-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5105.4G": {
          "2014-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5110C": {
          "2014-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5115.4G": {
          "2014-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5120C": {
          "2014-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6160.4": {
          "2022-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "6170.4": {
          "2022-Present": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "7200ST": {
          "2014-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "7220ST": {
          "2014-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Agrofarm 410": {
          "2009-2014": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agrofarm 420": {
          "2009-2014": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agrofarm 430": {
          "2009-2014": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus  310": {
          "2009-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus  310 Ecoline": {
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus  315": {
          "2009-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus  315 Ecoline": {
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus  320": {
          "2009-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus  320 Ecoline": {
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus  410": {
          "2009-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus  410 Ecoline": {
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus 100": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus 60": {
          "1997-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus 70": {
          "1997-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus 75": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus 80": {
          "2001-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus 85": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroplus 95": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agroprima 4.31": {
          "1989-1995": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "Agroprima 4.51": {
          "1989-1995": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "Agroprima 4.56": {
          "1991-1995": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "Agroprima 6.06": {
          "1990-1995": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "Agroprima 6.16": {
          "1991-1995": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "Agrostar 6.11": {
          "1990-1993": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Agrostar 6.21": {
          "1992-1993": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Agrostar 6.31": {
          "1990-1993": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Agrostar 6.61": {
          "1990-1995": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Agrostar 6.71": {
          "1992-1993": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Agrostar 6.81": {
          "1992-1993": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Agrostar DX4.61": {
          "1990-1993": {
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Agrostar DX4.71": {
          "1990-1993": {
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Agrotron 100": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agrotron 105": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agrotron 106": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agrotron 108": {
          "2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agrotron 110": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2004-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 1130TTV": {
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 1145TTV": {
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 115": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 1160TTV": {
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 118": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 120": {
          "1997-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2000-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
          },
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 128": {
          "2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 130": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 130.6": {
          "2005-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 135": {
          "1997-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2000-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 140": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 150": {
          "1997-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2000-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          },
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 150.7": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 155": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 160": {
          "1997-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2000-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 165": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 165.7": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 175": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 180.7": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 200": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          },
          "2004-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 205": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 210": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 215": {
          "2004-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 230": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 235": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 260": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 265": {
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2004-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron 4.70": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 4.80": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 4.85": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 4.90": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 4.95": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 6.00": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 6.05": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 6.15": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 6.20": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 6.30": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 6.45": {
          "1995-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 6120.4": {
          "2013-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6120.4TTV": {
          "2013-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6130.4": {
          "2013-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6130.4TTV": {
          "2013-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6140": {
          "2013-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6140.4": {
          "2013-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6140.4TTV": {
          "2013-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6150": {
          "2011-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6150.4": {
          "2012-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6150.4TTV": {
          "2012-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6160": {
          "2011-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6160.4": {
          "2012-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6160.4TTV": {
          "2012-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6160TTV": {
          "2011-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6180": {
          "2011-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6180TTV": {
          "2011-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6190": {
          "2011-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6190TTV": {
          "2011-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 6210": {
          "2014-2016": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 7210TTV": {
          "2011-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          },
          "2012-2016": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 7230TTV": {
          "2012-2016": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron 7250TTV": {
          "2012-2016": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Agrotron 80": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 85": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron 90": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Agrotron K100": {
          "2005-2008": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "Agrotron K110": {
          "2005-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "Agrotron K120": {
          "2005-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "Agrotron K410": {
          "2008-2013": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "Agrotron K420": {
          "2008-2013": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "Agrotron K430": {
          "2008-2014": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "Agrotron K610": {
          "2008-2014": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "Agrotron K90": {
          "2005-2008": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "Agrotron L710": {
          "2009-2013": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron L720": {
          "2006-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2008-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron L730": {
          "2012-2013": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron M410": {
          "2009-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron M420": {
          "2009-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Agrotron M600": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron M610": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron M615": {
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron M620": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron M625": {
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron M630": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron M640": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron M650": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Agrotron TTV410": {
          "2011-2013": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron TTV420": {
          "2011-2013": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron TTV430": {
          "2011-2014": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron TTV610": {
          "2007-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Agrotron TTV620": {
          "2007-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron TTV630": {
          "2008-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Agrotron X710": {
          "2006-2013": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Agrotron X720": {
          "2006-2013": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "AgroXtra3.57": {
          "1991-1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "AgroXtra4.07": {
          "1991-1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "AgroXtra4.17": {
          "1990-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "AgroXtra4.47": {
          "1993-1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "AgroXtra4.57": {
          "1991-1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "AgroXtra6.07": {
          "1991-1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "AgroXtra6.17": {
          "1991-1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX110": {
          "1978-1982": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX120": {
          "1980-1983": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX140": {
          "1980-1983": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX145": {
          "1980-1983": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX160": {
          "1978-1983": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX230": {
          "1980-1982": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX250": {
          "1982-1983": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX3.10": {
          "1984-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX3.30": {
          "1984-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX3.50": {
          "1984-1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX3.60": {
          "1986-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX3.65": {
          "1987-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX3.70": {
          "1984-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX3.90": {
          "1984-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX4.10": {
          "1985-1988": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX4.30": {
          "1983-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX4.50": {
          "1983-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX4.70": {
          "1983-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX6.05": {
          "1987-1991": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX6.10": {
          "1983-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX6.30": {
          "1983-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX6.50": {
          "1983-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX7.10": {
          "1984-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX8.30": {
          "1983-1988": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX80": {
          "1982-1983": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX85": {
          "1978-1982": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX86": {
          "1982-1983": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX90": {
          "1978-1982": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "DX92": {
          "1982-1983": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      }
  },
  "Fendt": {
      "620": {
          "2024-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              }
          }
      },
      "1038 Vario": {
          "2015-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "1042 Vario": {
          "2015-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "1046 Vario": {
          "2015-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "1050 Vario": {
          "2015-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "206S": {
          "2003-2009": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "207 F Vario": {
          "2017-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          },
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "207 V Vario": {
          "2017-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          },
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "207 Vario": {
          "2010-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          },
          "2017-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
          },
          "2021-2023": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
          },
          "2024-Present": {
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
          }
      },
      "207F Vario": {
          "2017-2021": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              }
          }
      },
      "207S": {
          "2003-2009": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "208 F Vario": {
          "2017-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          },
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "208 V Vario": {
          "2017-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          },
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "208 Vario": {
          "2010-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          },
          "2017-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
          },
          "2021-2023": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
          },
          "2024-Present": {
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
          }
      },
      "208S": {
          "2003-2009": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "209 F Vario": {
          "2017-2021": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          },
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "209 P Vario": {
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "209 V Vario": {
          "2017-2021": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          },
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "209 Vario": {
          "2010-2017": {
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          },
          "2017-2021": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
          },
          "2021-2023": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
          },
          "2024-Present": {
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
          }
      },
      "209S": {
          "2003-2009": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "210 F Vario": {
          "2017-2021": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          },
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "210 P Vario": {
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "210 V Vario": {
          "2017-2021": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          },
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "210 Vario": {
          "2010-2017": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          },
          "2017-2021": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
          },
          "2021-2023": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
          },
          "2024-Present": {
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
          }
      },
      "211 F Vario": {
          "2017-2021": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          },
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "211 P Vario": {
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "211 V Vario": {
          "2017-2021": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          },
          "2021-Present": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "211 Vario": {
          "2010-2017": {
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              }
          },
          "2017-2021": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
          },
          "2021-2023": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
          },
          "2024-Present": {
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
          }
      },
      "309 Vario": {
          "2006-2012": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "309 Vario SCR": {
          "2012-2015": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "310 Vario": {
          "2006-2012": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "310 Vario S4": {
          "2014-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "310 Vario SCR": {
          "2012-2015": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "311 Vario": {
          "2006-2012": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "311 Vario gen 4": {
          "2021-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "311 Vario S4": {
          "2014-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "312 Vario": {
          "2006-2012": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "312 Vario gen 4": {
          "2021-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "312 Vario S4": {
          "2014-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "312 Vario SCR": {
          "2012-2015": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "313 Vario gen 4": {
          "2021-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "313 Vario S4": {
          "2014-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "313 Vario SCR": {
          "2012-2015": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "314 Vario gen 4": {
          "2021-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "409 Vario": {
          "1999-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "410 Vario": {
          "1999-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "411 Vario": {
          "2006-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "412 Vario": {
          "2006-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "413 Vario": {
          "2006-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "414 Vario": {
          "2006-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "415 Vario": {
          "2006-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "512 Vario Gen 3": {
          "2021-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "512 Vario S4": {
          "2015-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "512 Vario SCR": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "513 Vario Gen 3": {
          "2021-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "513 Vario S4": {
          "2015-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "513 Vario SCR": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "514 Vario S4": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "514 Vario SCR": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "516 Vario Gen 3": {
          "2021-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "516 Vario S4": {
          "2015-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "516 Vario SCR": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "711 Vario": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "712 Vario": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2006-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "714 Vario": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2006-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "714 Vario gen 6": {
          "2020-2024": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "714 Vario S4": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "714 Vario SCR": {
          "2010-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "716 Vario": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2006-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "716 Vario gen 6": {
          "2020-2024": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "716 Vario S4": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "716 Vario SCR": {
          "2010-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "718 Vario": {
          "2006-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "718 Vario gen 6": {
          "2020-2024": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "718 Vario S4": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              }
          }
      },
      "718 Vario SCR": {
          "2010-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "720 Vario gen 6": {
          "2020-2024": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "720 Vario gen 7": {
          "2023-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "720 Vario S4": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "720 Vario SCR": {
          "2010-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "722 Vario gen 6": {
          "2020-2024": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "722 Vario gen 7": {
          "2023-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "722 Vario S4": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "722 Vario SCR": {
          "2010-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "724 Vario gen 6": {
          "2020-2024": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "724 Vario gen 7": {
          "2023-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "724 Vario S4": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "724 Vario SCR": {
          "2010-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "726 Vario gen 7": {
          "2023-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "728 Vario gen 7": {
          "2023-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "815 Vario": {
          "2002-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-led-rear-lights-package-flpp": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "816 Vario": {
          "2002-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "818 Vario": {
          "2002-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "818 VarioTMS": {
          "2006-2010": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "819 Vario": {
          "2009-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "820 VarioTMS": {
          "2006-2010": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "822 Vario S4": {
          "2014-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "822 Vario SCR": {
          "2010-2014": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "824 Vario S4": {
          "2014-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "824 Vario SCR": {
          "2010-2014": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "826 Vario S4": {
          "2014-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "826 Vario SCR": {
          "2010-2014": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "828 Vario S4": {
          "2014-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "828 Vario SCR": {
          "2010-2014": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "916 Vario": {
          "2000-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2002-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "920 Vario": {
          "2000-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2002-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "922 Vario": {
          "2006-2010": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "924 Vario": {
          "2000-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2002-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2006-2010": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          },
          "2010-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "926 Vario": {
          "2000-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2002-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2006-2010": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
          }
      },
      "927 Vario": {
          "2006-2010": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2010-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "927 Vario S4": {
          "2015-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "927 Vario SCR": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "930 Vario": {
          "2002-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2006-2010": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          },
          "2010-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "930 Vario gen 6": {
          "2019-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "930 Vario S4": {
          "2015-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "930 Vario SCR": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "933 Vario": {
          "2006-2010": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          },
          "2010-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "933 Vario gen 6": {
          "2019-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "933 Vario S4": {
          "2015-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "933 Vario SCR": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "936 Vario": {
          "2010-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "936 Vario gen 6": {
          "2019-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "936 Vario S4": {
          "2015-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "936 Vario SCR": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "939 Vario": {
          "2010-2013": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "939 Vario gen 6": {
          "2019-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "939 Vario S4": {
          "2015-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "939 Vario SCR": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
          }
      },
      "942 Vario gen 6": {
          "2019-2022": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
          }
      },
      "Farmer 102(S)": {
          "1972-1974": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          },
          "1972-1984": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 102LS(A)": {
          "1981-1982": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 103(S)": {
          "1972-1974": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          },
          "1972-1987": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 103LS(A)": {
          "1978-1982": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 104(S)": {
          "1972-1982": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 104LS(A)": {
          "1978-1982": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 105(S)": {
          "1972-1974": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          },
          "1972-1985": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 105LS(A)": {
          "1976-1980": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 106(S)": {
          "1972-1980": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 106LS(A)": {
          "1976-1980": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 108(S)": {
          "1974-1982": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 108LS(A)": {
          "1977-1980": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 200S": {
          "1974-1987": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 200SA": {
          "1974-1982": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Farmer 201S": {
          "1975-1987": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
          }
      },
      "Farmer 201SA": {
          "1976-1987": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
          }
      },
      "Farmer 240S": {
          "1987-1993": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 250S": {
          "1987-1996": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1996-2003": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 260S": {
          "1987-1996": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1996-2003": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 275S": {
          "1987-1996": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 280S": {
          "1996-2003": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 303LS(A)": {
          "1982-1985": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
          }
      },
      "Farmer 304LS(A)": {
          "1982-1987": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
          },
          "1982-1990": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1990-1998": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 305LS(A)": {
          "1980-1984": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1984-1987": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
          },
          "1990-1993": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 306LS(A)": {
          "1980-1984": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1984-1990": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
          },
          "1990-1993": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 307": {
          "1993-1998": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 307C": {
          "1997-2001": {
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "2001-2003": {
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 307Ci": {
          "2003-2008": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 307LS(A)": {
          "1985-1987": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
          },
          "1985-1990": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1990-1993": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 308": {
          "1993-2001": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 308C": {
          "1997-2001": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "2001-2003": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 308Ci": {
          "2003-2008": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 308LS(A)": {
          "1980-1984": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1984-1987": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
          },
          "1987-1990": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1990-1998": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 309": {
          "1993-2001": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 309C": {
          "1997-2001": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "2001-2003": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 309Ci": {
          "2003-2007": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 309LS(A)": {
          "1981-1984": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1984-1987": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
          },
          "1984-1990": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1990-1998": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 310": {
          "1993-2001": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 310LS(A)": {
          "1984-1990": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1990-1993": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 311": {
          "1993-2001": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 311LS(A)": {
          "1984-1990": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1990-1993": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 312": {
          "1993-2001": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 312LS(A)": {
          "1987-1990": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 312LSA": {
          "1990-1993": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 409 Vario": {
          "1999-2004": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 410 Vario": {
          "1999-2004": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 411 Vario": {
          "1999-2004": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Farmer 412 Vario": {
          "2001-2004": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Favorit 10S(A)": {
          "1970-1972": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Favorit 11S(A)": {
          "1970-1972": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Favorit 12S(A)": {
          "1970-1972": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Favorit 3S(A)": {
          "1967-1970": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Favorit 4S(A)": {
          "1967-1970": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Favorit 610S(A)(L)": {
          "1972-1976": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          },
          "1976-1978": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Favorit 611S(A)(L)": {
          "1972-1976": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          },
          "1976-1979": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Favorit 612S(A)(L)": {
          "1972-1976": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          },
          "1976-1979": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Favorit 614S(A)(L)": {
          "1974-1976": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          },
          "1976-1979": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Favorit 615SL": {
          "1976-1979": {
              "crawer-led-plough-lamp-20w-cr-1066": {
                  
              }
          }
      },
      "Favorit509C": {
          "1994-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit510C": {
          "1993-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit511C": {
          "1994-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit512C": {
          "1993-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit514C": {
          "1993-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit515C": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit600LS": {
          "1979-1982": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit610LS": {
          "1979-1984": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit611LS": {
          "1979-1984": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit611LS(A)": {
          "1984-1987": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "1987-1993": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit612LS": {
          "1979-1984": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit612LS(A)": {
          "1984-1987": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "1987-1993": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit614LS": {
          "1979-1984": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit614LS(A)": {
          "1984-1987": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "1987-1993": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit615LS": {
          "1979-1984": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit615LS(A)": {
          "1984-1987": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "1987-1993": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit711 Vario": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit712 Vario": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit714 Vario": {
          "1998-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit716 Vario": {
          "1998-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit816": {
          "1993-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit818": {
          "1993-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit822": {
          "1993-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit824": {
          "1993-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit916 Vario": {
          "1997-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit920 Vario": {
          "1997-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit924 Vario": {
          "1997-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Favorit926 Vario": {
          "1996-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      }
  },
  "Fiat Fiatagri": {
      "100-90": {
          "1984-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "110-90": {
          "1986-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "115-90 DT": {
          "1984-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1180 DT": {
          "1979-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1280 DT Turbo": {
          "1979-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "130-90 DT": {
          "1984-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1380 DT Turbo": {
          "1979-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "140-90 DT": {
          "1984-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1580 DT": {
          "1979-1982": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1580 DT Turbo": {
          "1982-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "160-90 DT": {
          "1984-1994": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "180-90 DT": {
          "1984-1994": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1880 DT Turbo": {
          "1979-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "35-66": {
          "1990-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "45-66s": {
          "1992-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "50-66s": {
          "1992-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "55-66s": {
          "1992-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "55-88": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "55-90": {
          "1984-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "580 DT": {
          "1978-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "60-66s DT": {
          "1992-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "60-88": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "60-90": {
          "1984-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "60-94": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "65-66s DT": {
          "1992-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "65-88": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "65-90": {
          "1987-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "65-94": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "680 DT": {
          "1978-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "70-66s DT": {
          "1992-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "70-88": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "70-90 DT": {
          "1984-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "72-94": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "780 DT": {
          "1975-1978": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "1978-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "80-66s DT": {
          "1992-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "80-88": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "80-90 DT": {
          "1984-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "82-94": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "85-90 DT": {
          "1984-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "880 DT": {
          "1975-1978": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "1978-1980": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "88-94 Turbo": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "90-90": {
          "1984-1991": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "95-90": {
          "1992-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "F 100 DT": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "F 115 DT": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "F 130 DT": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "F 140 DT": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "M100": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "M115": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "M135": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "M160": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      }
  },
  "Ford": {
      "5640": {
          "1992-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6610": {
          "1981-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6640": {
          "1992-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6710": {
          "1981-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7610": {
          "1981-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7710": {
          "1981-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7740": {
          "1992-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "7840": {
          "1992-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8210": {
          "1982-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "8240": {
          "1992-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8340": {
          "1992-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8630": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "8730": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "8830": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5610Gen2": {
          "1985-1988": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5610Gen3": {
          "1988-1991": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6410Gen3": {
          "1988-1991": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6610Gen2": {
          "1985-1988": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6810Gen3": {
          "1988-1991": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7610Gen2": {
          "1985-1988": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7610Gen3": {
          "1988-1991": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7710Gen2": {
          "1985-1988": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7810Gen2": {
          "1985-1988": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7810Gen3": {
          "1988-1991": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7910Gen2": {
          "1985-1987": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "8210Gen2": {
          "1985-1988": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "8210Gen3": {
          "1988-1991": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      }
  },
  "John Deere": {
      "830": {
          "1975-1979": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "930": {
          "1975-1979": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "1030": {
          "1975-1979": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "1040": {
          "1979-1985": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "1130": {
          "1975-1979": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "1140": {
          "1979-1985": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "1630": {
          "1975-1979": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "1640": {
          "1979-1985": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "2030": {
          "1975-1979": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "2040": {
          "1979-1985": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "2130": {
          "1975-1979": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "2140": {
          "1979-1985": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "2250": {
          "1986-1994": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "2450": {
          "1986-1994": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "2650": {
          "1986-1994": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "2850": {
          "1986-1994": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "3030": {
          "1975-1979": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "3040": {
          "1979-1985": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "3050": {
          "1986-1993": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "3130": {
          "1975-1979": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "3140": {
          "1979-1985": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "3350": {
          "1986-1993": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "3650": {
          "1986-1993": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "5400": {
          "1996-2000": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "5500": {
          "1998-2000": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "5620": {
          "2003-2009": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "5720": {
          "2003-2009": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "5820": {
          "2003-2009": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6020": {
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6100": {
          "1990-2007": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6110": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6120": {
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6130": {
          "2007-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          },
          "2011-2013": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
          }
      },
      "6200": {
          "1992-1997": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6210": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6220": {
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6230": {
          "2007-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          },
          "2011-2013": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
          }
      },
      "6300": {
          "1992-1997": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6310": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6320": {
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6330": {
          "2007-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          },
          "2011-2013": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
          }
      },
      "6400": {
          "1992-1997": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6410": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6420": {
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6430": {
          "2007-2012": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6506": {
          "1995-1997": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6510": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6520": {
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6530": {
          "2007-2009": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6534": {
          "2009-2012": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "6600": {
          "1993-1997": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6610": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6620": {
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6630": {
          "2007-2012": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6800": {
          "1993-1997": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6810": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6820": {
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6830": {
          "2007-2012": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
          }
      },
      "6900": {
          "1994-1997": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6910": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6920": {
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6930": {
          "2007-2012": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "7600": {
          "1992-1997": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1061": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "7610": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1061": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "7630": {
          "2006-2011": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1043set": {
                  
              },
              
              "crawer-led-65w-john-deere-work-light-cr-1045": {
                  
              }
          }
      },
      "7700": {
          "1992-1997": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1061": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "7710": {
          "1997-2003": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1061": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "7720": {
          "2003-2006": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1043set": {
                  
              },
              
              "crawer-led-65w-john-deere-work-light-cr-1045": {
                  
              }
          }
      },
      "7730": {
          "2006-2011": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1043set": {
                  
              },
              
              "crawer-led-65w-john-deere-work-light-cr-1045": {
                  
              }
          }
      },
      "7800": {
          "1992-1997": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1061": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "7810": {
          "1997-2003": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1061": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "7820": {
          "2003-2006": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1043set": {
                  
              },
              
              "crawer-led-65w-john-deere-work-light-cr-1045": {
                  
              }
          }
      },
      "7830": {
          "2006-2011": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1043set": {
                  
              },
              
              "crawer-led-65w-john-deere-work-light-cr-1045": {
                  
              }
          }
      },
      "7920": {
          "2003-2006": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1043set": {
                  
              },
              
              "crawer-led-65w-john-deere-work-light-cr-1045": {
                  
              }
          }
      },
      "7930": {
          "2006-2011": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-30w-john-deere-work-light-cr-1043set": {
                  
              },
              "crawer-led-65w-john-deere-work-light-cr-1045": {
                  
              },
          }
      },
      "8100": {
          "1994-1995": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          },
          "1995-1999": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "8110": {
          "1999-2001": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "8120": {
          "2001-2006": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "8130": {
          "2006-2009": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "8200": {
          "1994-1999": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "8210": {
          "1999-2001": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "8220": {
          "2001-2006": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "8230": {
          "2006-2009": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "8300": {
          "1994-1995": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          },
          "1995-1999": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "8310": {
          "1999-2001": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "8320": {
          "2001-2006": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "8330": {
          "2006-2009": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "8400": {
          "1994-1995": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          },
          "1995-1999": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "8410": {
          "1999-2001": {
              "crawer-led-spot-beam-work-lamp-65w-rectangle-40-degrees-cr-1007": {
                  
              },
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "8420": {
          "2001-2006": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "8430": {
          "2006-2009": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "8520": {
          "2001-2006": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "8530": {
          "2006-2009": {
              "crawer-led-65w-john-deere-work-light-cr-1037": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "5070M": {
          "2009-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          },
          "2011-2013": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          }
      },
      "5075GF": {
          "2018-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              }
          }
      },
      "5075M": {
          "2014-2017": {
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              }
          },
          "2018-2023": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          }
      },
      "5080M": {
          "2009-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          },
          "2011-2013": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          }
      },
      "5080R": {
          "2008-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          },
          "2011-2013": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          }
      },
      "5085M": {
          "2014-2016": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              }
          }
      },
      "5090GF": {
          "2018-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              }
          }
      },
      "5090M": {
          "2009-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          },
          "2011-2013": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          },
          "2016-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          },
          "2018-2023": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          }
      },
      "5090R": {
          "2008-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          },
          "2011-2013": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
          },
          "2016-2020": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5100M": {
          "2009-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          },
          "2011-2013": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          },
          "2018-2023": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          }
      },
      "5100R": {
          "2008-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          },
          "2011-2013": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
          },
          "2016-2020": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5105GF": {
          "2018-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              }
          }
      },
      "5115GF": {
          "2018-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              }
          }
      },
      "5115M": {
          "2016-2020": {
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2018-2023": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              }
          }
      },
      "5115R": {
          "2016-2020": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "5120ML": {
          "2022-Present": {
          }
      },
      "5125R": {
          "2016-2020": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6010SE": {
          "1998-2002": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
          }
      },
      "6020SE": {
          "2002-2007": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
          }
      },
      "6090M": {
          "2020-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6090MC": {
          "2014-2017": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2018-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6090RC": {
          "2014-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6095RC": {
          "2014-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6100M": {
          "2020-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6100MC": {
          "2014-2017": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2018-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6100RC": {
          "2014-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6105R": {
          "2012-2015": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6105RC": {
          "2014-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6110M": {
          "2016-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2020-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6110MC": {
          "2014-2017": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2018-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6110R": {
          "2016-2020": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6110RC": {
          "2014-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6110SE": {
          "1998-2002": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "6115M": {
          "2012-2016": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
          }
      },
      "6115R": {
          "2012-2016": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6115RC": {
          "2014-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6120M": {
          "2016-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2020-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6120R": {
          "2016-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6120SE": {
          "2002-2007": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "6125M": {
          "2012-2016": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6125R": {
          "2012-2016": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6130M": {
          "2012-2016": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2016-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2020-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6130R": {
          "2012-2016": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2016-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6135M": {
          "2016-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6135R": {
          "2016-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6140M": {
          "2012-2016": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2020-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6140R": {
          "2012-2016": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6145M": {
          "2016-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2020-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6145R": {
          "2016-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6150M": {
          "2012-2016": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6150R": {
          "2012-2016": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6155M": {
          "2016-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2020-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6155R": {
          "2016-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6170M": {
          "2012-2016": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6170R": {
          "2011-2014": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6175M": {
          "2016-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2020-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6175R": {
          "2014-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6190R": {
          "2011-2014": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6195M": {
          "2016-2020": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-john-deere-adapter-cable-cr-137": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          },
          "2020-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6195R": {
          "2014-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6210R": {
          "2011-2014": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6215R": {
          "2014-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6230 Premium": {
          "2006-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "6230R": {
          "2014-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6250R": {
          "2014-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6330 Premium": {
          "2006-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "6420S": {
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1010-60": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              },
          }
      },
      "6430 Premium": {
          "2006-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "6530 Premium": {
          "2006-2009": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "6534 Premium": {
          "2009-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "6630 Premium": {
          "2006-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "6830 Premium": {
          "2006-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "6910S": {
          "2000-2001": {
              "crawer-led-flood-beam-work-lamp-65w-rectangle-60-degrees-cr-1009": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-led-40w-john-deere-work-light-cr-1064": {
                  
              },
              "crawer-john-deere-led-work-light-set-of-four-wl20jd": {
                  
              }
          }
      },
      "6920S": {
          "2001-2003": {
          },
          "2001-2006": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1010-40": {
                  
              },
              "crawer-led-40w-john-deere-6020-series-cr-1020s": {
                  
              }
          }
      },
      "6930 Premium": {
          "2006-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "6R110": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R120": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R130": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R140": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R145": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R150": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R155": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R165": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R175": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6R185": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R195": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R215": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "6R230": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "6R250": {
          "2022-Present": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "7200R": {
          "2011-2013": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "7210R": {
          "2014-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      },
      "7215R": {
          "2011-2013": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "7230R": {
          "2011-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      },
      "7250R": {
          "2014-2020": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      },
      "7260R": {
          "2011-2013": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "7270R": {
          "2014-2022": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      },
      "7280R": {
          "2011-2013": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "7290R": {
          "2014-2020": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      },
      "7310R": {
          "2014-2020": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      },
      "7430 Premium": {
          "2006-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "7430E Premium": {
          "2008-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "7530 Premium": {
          "2006-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "7530E Premium": {
          "2008-2011": {
              "crawer-led-40-degrees-john-deere-work-light-cr-1011-40": {
                  
              },
              "crawer-led-60-degrees-john-deere-work-light-cr-1011-60": {
                  
              },
              "crawer-led-40w-john-deere-6030-7030-premium-cr-1012": {
                  
              }
          }
      },
      "8245R": {
          "2009-2011": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          },
          "2014-2021": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "8260R": {
          "2011-2013": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "8270R": {
          "2009-2011": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          },
          "2013-2021": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      },
      "8285R": {
          "2011-2013": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "8295R": {
          "2009-2011": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          },
          "2013-2021": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      },
      "8310R": {
          "2011-2013": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "8320R": {
          "2009-2011": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          }
      },
      "8335R": {
          "2011-2013": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "8345R": {
          "2009-2011": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-39w-oval-john-deere-work-light-cr-1038": {
                  
              }
          },
          "2013-2021": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      },
      "8360R": {
          "2011-2013": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-40-watt-built-in-work-light-crw015": {
                  
              }
          }
      },
      "8370R": {
          "2013-2021": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      },
      "8400R": {
          "2016-2021": {
              "crawer-john-deere-r-series-cab-oval-work-light-cr-1015": {
                  
              },
              "crawer-john-deere-r-series-recessed-led-work-light-cr-1018": {
                  
              },
              "crawer-led-built-in-work-light-set-john-deere-7r-8r-cr-1063s": {
                  
              },
          }
      }
  },
  "Kubota": {
      "M5091": {
          "2016-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "M5092": {
          "2020-2023": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "M5111": {
          "2016-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "M5112": {
          "2020-2023": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "M6121": {
          "2018-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M6122": {
          "2020-2023": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M6132": {
          "2020-2023": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M6142": {
          "2020-2023": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M7131": {
          "2015-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M7132": {
          "2018-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M7133": {
          "2020-2023": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M7151": {
          "2015-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M7152": {
          "2018-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M7163": {
          "2020-2023": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M7171": {
          "2015-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M7172": {
          "2018-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "M7173": {
          "2020-2023": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      }
  },
  "Landini": {
      "landpower  125": {
          "2007-2014": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "landpower  135": {
          "2007-2014": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "landpower  145": {
          "2007-2014": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "landpower  165": {
          "2007-2014": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "landpower  185": {
          "2007-2014": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Legend 105": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Legend 115": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Legend 120": {
          "2001-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2002-2003": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Legend 125": {
          "2003-2005": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Legend 130": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2002-2003": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Legend 135": {
          "2003-2005": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Legend 140": {
          "2001-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2002-2003": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Legend 145": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2003-2005": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Legend 160": {
          "2001-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2002-2003": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Legend 165": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2003-2005": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Legend 180": {
          "2001-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-square-work-light-cr-1016": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2002-2003": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-h9-h11-connector-female-za2003": {
                  
              }
          }
      },
      "Legend 185": {
          "2003-2005": {
              "crawer-40w-recessed-led-worklight-cr-1024": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Mistral 40": {
          "2004-2009": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          },
          "2009-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Mistral 45": {
          "2004-2009": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          },
          "2009-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Mistral 50": {
          "2004-2009": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          },
          "2009-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Mistral 55": {
          "2004-2009": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          },
          "2009-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "powerfarm 100": {
          "2008-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "powerfarm 110": {
          "2008-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "powerfarm 90": {
          "2008-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      }
  },
  "Lindner": {
      "Geotrac 100": {
          "1998-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 103": {
          "2002-2010": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 104": {
          "2008-2013": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 104 ep": {
          "2017-2020": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 104pro": {
          "2008-2013": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 114": {
          "2008-2013": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 114 ep": {
          "2012-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 124": {
          "2008-2013": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 134 ep": {
          "2012-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 50": {
          "1998-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 60": {
          "1998-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 63": {
          "2002-2010": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 64": {
          "2010-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 64EP": {
          "2017-2020": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 70": {
          "1998-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 73": {
          "2002-2010": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 74": {
          "2010-2017": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 74EP": {
          "2014-2020": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 80": {
          "1998-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 83": {
          "2002-2010": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 83t": {
          "2002-2010": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 84": {
          "2010-2013": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 84EP": {
          "2012-2020": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 93": {
          "2002-2010": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
          }
      },
      "Geotrac 94": {
          "2010-2013": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Geotrac 94EP": {
          "2014-2020": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Lintrac 100": {
          "2021-Present": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              }
          }
      },
      "Lintrac 110": {
          "2021-Present": {
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Lintrac 70 komfort cab": {
          "2020-Present": {
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Lintrac 80 komfort cab": {
          "2020-Present": {
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Lintrac 90": {
          "2014-2020": {
              "crawer-position-and-indicator-square-with-e-approval-set-crml-1orwi": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Unitrac 100": {
          "1998-2005": {
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Unitrac 95": {
          "1998-2005": {
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      }
  },
  "Massey Ferguson": {
      "255": {
          "1977-1983": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "3050": {
          "1986-1988": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1988-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3055": {
          "1993-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3060": {
          "1986-1988": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1988-1992": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1992-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3065": {
          "1992-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3070": {
          "1986-1988": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1988-1990": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3075": {
          "1993-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3080": {
          "1986-1988": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1988-1990": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3085": {
          "1993-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3090": {
          "1986-1988": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1988-1990": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3095": {
          "1990-1993": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1993-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3115": {
          "1990-1992": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1992-1993": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3120": {
          "1993-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3125": {
          "1990-1992": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1992-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3610": {
          "1987-1990": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3625": {
          "2013-2020": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3630": {
          "1987-1990": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2013-2020": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3635": {
          "1990-1992": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1992-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3640": {
          "2013-2020": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3645": {
          "1990-1992": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1992-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3650": {
          "1987-1990": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2013-2020": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3655": {
          "1990-1992": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1992-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3670": {
          "1990-1992": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1992-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3680": {
          "1989-1990": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3690": {
          "1990-1992": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1992-1994": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1994-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4215": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4220": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4225": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4235": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4245": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4255": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4260": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4270": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4355": {
          "2001-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4360": {
          "2001-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4365": {
          "2001-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4370": {
          "2001-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "4435": {
          "2004-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2006-2011": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4445": {
          "2006-2011": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4455": {
          "2004-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2006-2011": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4708": {
          "2019-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "4709": {
          "2019-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "4710": {
          "2019-Present": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5425": {
          "2003-2008": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2008-2011": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5435": {
          "2003-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2006-2008": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2008-2011": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5445": {
          "2003-2008": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2008-2013": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5455": {
          "2003-2008": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2008-2013": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5460": {
          "2003-2007": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5465": {
          "2003-2007": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2010": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2010-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5470": {
          "2006-2007": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5475": {
          "2007-2010": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2010-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5480": {
          "2007-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5608": {
          "2013-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5609": {
          "2013-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5610": {
          "2013-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5611": {
          "2014-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5612": {
          "2014-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5613": {
          "2014-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5708": {
          "2017-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5709": {
          "2017-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5710": {
          "2016-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5711": {
          "2016-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "6110": {
          "1995-1997": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6120": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6130": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6140": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6150": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6160": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6170": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6180": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6190": {
          "1996-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6235": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6245": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6255": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6260": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6265": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6270": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6280": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6290": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "6445": {
          "2003-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2007": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2013": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6455": {
          "2003-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2007": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2013": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6460": {
          "2003-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2007": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6465": {
          "2003-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2007": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2010": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2010-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6470": {
          "2003-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2007": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2013": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6475": {
          "2003-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2007": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2010": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2010-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6480": {
          "2003-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2007": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2010": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2010-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6485": {
          "2003-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2006-2011": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6490": {
          "2003-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2006-2011": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6495": {
          "2003-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2006-2011": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6497": {
          "2004-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2006-2011": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6499": {
          "2004-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2006-2011": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6612": {
          "2013-2016": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6613": {
          "2013-2016": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6614": {
          "2013-2016": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6615": {
          "2013-2016": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6616": {
          "2013-2016": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6712": {
          "2016-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "6713": {
          "2016-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "7140": {
          "2009-2015": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7150": {
          "2009-2015": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7170": {
          "2009-2015": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7180": {
          "2009-2015": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7465": {
          "2003-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7475": {
          "2003-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7480": {
          "2003-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2007-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7485": {
          "2003-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2006-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7490": {
          "2003-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2006-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7495": {
          "2003-2006": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2006-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7497": {
          "2009-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7499": {
          "2009-2012": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7614": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7615": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7616": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7618": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7619": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7620": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7622": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7624": {
          "2012-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7626": {
          "2013-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "7714": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "7715": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "7716": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "7718": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "7719": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "7720": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "7722": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "7724": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "7726": {
          "2015-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "8110": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8120": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8130": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8140": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8150": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8160": {
          "1995-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8170": {
          "1998-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8180": {
          "1998-1999": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8210": {
          "1999-2003": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8220": {
          "1999-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8240": {
          "1999-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8250": {
          "1999-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8260": {
          "1999-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8270": {
          "1999-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8280": {
          "1999-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8450": {
          "2004-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2008": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8460": {
          "2004-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2008": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8470": {
          "2004-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2008": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8480": {
          "2004-2005": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2005-2008": {
              "crawer-inset-cab-led-worklight-cr-1008": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8650": {
          "2008-2011": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2011-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8660": {
          "2008-2011": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2011-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8670": {
          "2008-2011": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2011-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8680": {
          "2008-2011": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2011-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8690": {
          "2008-2011": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          },
          "2011-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8727": {
          "2014-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8730": {
          "2014-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8732": {
          "2014-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8735": {
          "2014-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8737": {
          "2014-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "8740": {
          "2017-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "3050E": {
          "1988-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3060E": {
          "1988-1992": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3060Panorama": {
          "1988-1993": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3070E": {
          "1990-1993": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "3AL.105": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3AL.115": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3AL.75": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3AL.85": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3AL.95": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3FR.105": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3FR.115": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3FR.75": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3FR.85": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3FR.95": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3SP.105": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3SP.115": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3SP.75": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3SP.85": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3SP.95": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3VI.105": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3VI.115": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3VI.75": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3VI.85": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3VI.95": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3WF.105": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3WF.115": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3WF.75": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3WF.85": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "3WF.95": {
          "2022-Present": {
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "5707S": {
          "2017-2021": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
          }
      },
      "5710S": {
          "2017-2021": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5710SL": {
          "2015-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5711S": {
          "2017-2021": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5711SL": {
          "2015-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5712S": {
          "2017-2021": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5712SL": {
          "2015-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5713S": {
          "2017-2021": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5713SL": {
          "2015-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "5S.105": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "5S.115": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "5S.125": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "5S.135": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "5S.145": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "6612S": {
          "2016-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "6613S": {
          "2016-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "6614Dyna-VT": {
          "2013-2016": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6615Dyna-VT": {
          "2013-2016": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6616Dyna-VT": {
          "2013-2016": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-adapter-cable-deutsch-dt-to-massey-ferguson-st7022": {
                  
              }
          }
      },
      "6713S": {
          "2016-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "6714S": {
          "2016-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "6715S": {
          "2016-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "6716S": {
          "2016-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "6718S": {
          "2016-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
          }
      },
      "6S.135": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "6S.145": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "6S.155": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "6S.165": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "6S.180": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "7S.155": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "7S.165": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "7S.180": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "7S.190": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "7S.210": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "8220Xtra": {
          "2002-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8240Xtra": {
          "2002-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8250Xtra": {
          "2002-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8260Xtra": {
          "2002-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8270Xtra": {
          "2002-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8280Xtra": {
          "2002-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8S.205": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "8S.225": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "8S.245": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "8S.265": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "8S.305": {
          "2021-2024": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "S9.310": {
          "2023-Present": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "S9.340": {
          "2023-Present": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "S9.370": {
          "2023-Present": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "S9.400": {
          "2023-Present": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      },
      "S9.425": {
          "2023-Present": {
              "crawer-led-work-lamp-50w-massey-ferguson-s-series-cr-1060": {
                  
              },
          }
      }
  },
  "McCormick": {
      "Cx100": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Cx105": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Cx110": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Cx65L": {
          "2005-2015": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Cx70L": {
          "2005-2015": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Cx75": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Cx75L": {
          "2005-2015": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Cx80": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Cx80L": {
          "2005-2015": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Cx85": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Cx90": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Gm 40": {
          "2009-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Gm 45": {
          "2009-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Gm 50": {
          "2009-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Gm 55": {
          "2004-2009": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          },
          "2009-2016": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "GX 40": {
          "2004-2009": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "GX 45": {
          "2004-2009": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "GX 50": {
          "2004-2009": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
          }
      },
      "Mc105": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mc110": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mc115": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mc120": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mc125": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mc130": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mc135": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mc95": {
          "2003 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx110": {
          "2000 - 2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx120": {
          "2004 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx125": {
          "2000 - 2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx135": {
          "2004 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx140": {
          "2000 - 2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx150": {
          "2004 - 2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx155": {
          "2000 - 2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx165": {
          "2004 - 2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx175": {
          "2000 - 2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx185": {
          "2004 - 2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Mtx200": {
          "2003 - 2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "XTX145": {
          "2008-2013": {
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "XTX165": {
          "2008-2013": {
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "XTX185": {
          "2008-2013": {
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "XTX200": {
          "2008-2013": {
              "crawer-fendt-sc4-round-led-work-light-cr-1021": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      }
  },
  "Mercedes": {
      "MB-trac 1000": {
          "1982-1991": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 1100": {
          "1982-1991": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 1300": {
          "1982-1987": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 1300 turbo": {
          "1987-1991": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 1400 turbo": {
          "1987-1991": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 1500": {
          "1980-1987": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 1600": {
          "1987-1991": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 1800": {
          "1990-1991": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 700": {
          "1982-1991": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 800": {
          "1982-1991": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 900": {
          "1981-1982": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "MB-trac 900 turbo": {
          "1982-1991": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      }
  },
  "New Holland": {
      "8160": {
          "1996-1999": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8260": {
          "1996-1999": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8360": {
          "1996-1999": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8560": {
          "1996-1999": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8670": {
          "1993-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8770": {
          "1993-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8870": {
          "1993-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "8970": {
          "1993-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "M100": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "M115": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "M135": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "M160": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "T4.105": {
          "2012-2017": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "T4.115": {
          "2013-2017": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T4.75": {
          "2013-2017": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T4.85": {
          "2012-2017": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T4.95": {
          "2012-2017": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T5.100": {
          "2016-2019": {
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "T5.105": {
          "2012-2017": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "T5.105EC": {
          "2013-2016": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "T5.110": {
          "2016-2019": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "T5.115": {
          "2012-2017": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "T5.115EC": {
          "2013-2016": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "T5.120": {
          "2016-2019": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "T5.95": {
          "2012-2017": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "T5.95EC": {
          "2013-2016": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "T5030": {
          "2008-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T5040": {
          "2008-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T5050": {
          "2008-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T5060": {
          "2008-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T5070": {
          "2009-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6.120": {
          "2012-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T6.125": {
          "2016-2019": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6.140": {
          "2012-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T6.140AC": {
          "2012-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T6.145": {
          "2016-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6.145AC": {
          "2016-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6.150": {
          "2012-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T6.150AC": {
          "2012-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T6.155": {
          "2012-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          },
          "2016-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2020-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6.155AC": {
          "2016-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6.160": {
          "2012-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          },
          "2019-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6.160AC": {
          "2012-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T6.165": {
          "2012-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          },
          "2016-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6.165AC": {
          "2016-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6.175": {
          "2012-2016": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          },
          "2016-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2020-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6.175AC": {
          "2016-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6.180": {
          "2016-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2019-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T6010Delta": {
          "2007-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6010Plus": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6020Delta": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6020Elite": {
          "2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6020Plus": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6030Delta": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6030Elite": {
          "2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6030Plus": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6030RC\/PC": {
          "2007-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6040Elite": {
          "2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6050Delta": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6050Elite": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2012-2013": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6050Plus": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6050RC\/PC": {
          "2007-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6060Elite": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2012-2013": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6070Elite": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2012-2013": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6070Plus": {
          "2007-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6070RC\/PC": {
          "2007-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6080RC\/PC": {
          "2007-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T6090RC\/PC": {
          "2009-2012": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T7.165S": {
          "2017-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2020-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.170": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.170AC": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.175": {
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2020-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.175AC": {
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.185": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.185AC": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.190": {
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2020-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.190AC": {
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.195S": {
          "2017-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.200": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.200AC": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.210": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          },
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2020-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.210AC": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          },
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.215S": {
          "2017-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.220": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.220AC": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.225": {
          "2020-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.225AC": {
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.230": {
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2023-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.230AC": {
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.235": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.235AC": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.240": {
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.245": {
          "2022-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.245AC": {
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.250": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.250AC": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7.260": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          },
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          },
          "2023-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.260AC": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          },
          "2015-2022": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.270": {
          "2019-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.270AC": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          },
          "2015-2019": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.290": {
          "2019-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.290AC": {
          "2015-2022": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.290HD": {
          "2019-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.315": {
          "2019-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.315AC": {
          "2015-2022": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.315HD": {
          "2020-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7.340HD": {
          "2023-Present": {
              "crawer-built-in-work-light-set-new-holland-crw016": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "T7030AC": {
          "2009-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T7030PC": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T7040AC": {
          "2009-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T7040PC": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T7050AC": {
          "2009-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T7050PC": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T7060AC": {
          "2009-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T7060PC": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T7070AC": {
          "2009-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T7510": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7520": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7530": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7540": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T7550": {
          "2007-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "T8.275": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8.300": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8.320": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8.330": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8.350": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8.360": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8.380": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8.390": {
          "2011-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8.410": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8.420": {
          "2013-2015": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8.435": {
          "2015-2020": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-50-watt-oval-worklight-led-cr-1036": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8020": {
          "2006-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8030": {
          "2006-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8040": {
          "2006-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T8050": {
          "2007-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TD5.105": {
          "2012-2015": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          },
          "2015-2019": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "TD5.115": {
          "2012-2015": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          },
          "2015-2019": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "TD5.65": {
          "2012-2015": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "TD5.75": {
          "2012-2015": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "TD5.85": {
          "2012-2015": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          },
          "2015-2022": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "TD5.95": {
          "2012-2015": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          },
          "2015-2022": {
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-40w-oval-led-work-lamp-4000-lumen-adjustable-crw4044": {
                  
              }
          }
      },
      "TG230": {
          "2002-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TG255": {
          "2002-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TG285": {
          "2002-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TL100": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TL100A": {
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TL70": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TL70A": {
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TL80": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TL80A": {
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TL90": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TL90A": {
          "2004-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TM115": {
          "1999-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TM120": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TM125": {
          "1999-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TM130": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TM135": {
          "1999-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TM140": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TM150": {
          "1999-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TM155": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TM165": {
          "1999-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TM175": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TM190": {
          "2002-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-corner-led-work-light-set-for-new-holland-tm-ford-cr-1068": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TS100": {
          "1997-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TS100A": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS100ADelta": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS100APlus": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS110": {
          "1997-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TS110A": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS110ADelta": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS110APlus": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS115": {
          "1998-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TS115A": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS115ADelta": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS115APlus": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS125A": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS125APlus": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS130ADelta": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS135A": {
          "2003-2005": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS135APlus": {
          "2005-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-built-in-work-light-40w-cree-cr-1014": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "TS90": {
          "1997-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "TVT135": {
          "2004-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "TVT145": {
          "2004-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "TVT155": {
          "2004-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "TVT170": {
          "2004-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "TVT190": {
          "2004-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      },
      "TVT195": {
          "2005-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-40w-cree-built-in-work-light-for-new-holland-crw013": {
                  
              }
          }
      }
  },
  "Renault": {
      "103-12\/14": {
          "1986-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "103-12TX": {
          "1981-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "103-14TX": {
          "1981-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "103-52\/54": {
          "1991-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "106-14SP": {
          "1983-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "106-54TL": {
          "1992-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "110-14": {
          "1986-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "110-54": {
          "1991-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "113-12TX": {
          "1981-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "113-14TX": {
          "1981-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "120-14": {
          "1986-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "120-54": {
          "1991-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "133-14": {
          "1986-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "133-14TX": {
          "1981-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "133-54": {
          "1991-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "145-14": {
          "1986-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "145-14TX": {
          "1981-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "145-54": {
          "1991-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "155-54": {
          "1991-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "160-94TZ": {
          "1993-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "175-74TZ": {
          "1989-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "180-94TZ": {
          "1991-1997": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "75-12TS": {
          "1982-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "75-14TS": {
          "1982-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "75-32TX": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "75-34TX": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "77-12TS": {
          "1986-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "77-14TS": {
          "1986-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "80-12TS": {
          "1984-1987": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "80-14TS": {
          "1984-1987": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "85-12TS\/TX": {
          "1986-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "85-14TS\/TX": {
          "1986-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "85-32TX": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "85-34TX": {
          "1989-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "90-32TX": {
          "1989-1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "90-34TX": {
          "1989-1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "95-12\/14": {
          "1986-1989": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "95-12TX": {
          "1982-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "95-14TX": {
          "1982-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 540": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 546": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 550": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 556": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 566": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 610": {
          "1996-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 616": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 620": {
          "1996-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 626": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 630": {
          "1996-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 636": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 640": {
          "1997-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 696": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 710": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 715": {
          "2000-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 720": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 725": {
          "1998-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 735": {
          "1998-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 815": {
          "1998-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 816": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 825": {
          "1998-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 826": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ares 836": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 310": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 320": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 325": {
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 330": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 335": {
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 340": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 345": {
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 355": {
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 65": {
          "1994-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 75": {
          "1994-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 85": {
          "1994-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Ceres 95": {
          "1994-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Cergos 330": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Cergos 335": {
          "2001-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Cergos 340": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Cergos 350": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Cergos 355": {
          "2001-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Temis 550": {
          "2000-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Temis 610": {
          "2000-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Temis 630": {
          "2000-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Temis 650": {
          "2000-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      }
  },
  "Same": {
      "AntAres  100": {
          "1989 - 1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "AntAres  110": {
          "1989 - 1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1995-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "AntAres  130": {
          "1989 - 1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1995-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Centauro 70": {
          "1981-1987": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Centurion 75": {
          "1978-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Diamond 215": {
          "2004 - 2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2004-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Diamond 230": {
          "1999-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2004 - 2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          },
          "2004-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Diamond 260": {
          "1999-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Diamond 265": {
          "2004-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Diamond 270": {
          "2004 - 2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Dorado 55": {
          "2000-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 56": {
          "2004-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 56 classic": {
          "2008-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 60": {
          "1995-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 65": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 66": {
          "2004-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 66 classic": {
          "2008-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 70": {
          "2004-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 75": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 76": {
          "2004-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 76 classic": {
          "2008-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 85": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 86": {
          "2004-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Dorado 86 classic": {
          "2008-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Explorer 55": {
          "1983-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer 60": {
          "1983-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer 65": {
          "1983-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer 70": {
          "1986-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer 75": {
          "1983-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer 80": {
          "1986-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer 85": {
          "1984-1986": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer 90": {
          "1986-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer 95": {
          "1986-1990": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer II 60": {
          "1989-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer II 70": {
          "1989-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer II 80": {
          "1989-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Explorer II 90": {
          "1989-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Hercules 160": {
          "1979-1983": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Iron 100": {
          "2009-2013": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Iron 110": {
          "2006-2008": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Iron 120": {
          "2006-2008": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Iron 130": {
          "2008-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Iron 140": {
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Iron 150": {
          "2009-2012": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Iron 165": {
          "2004-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
              "crawer-mounting-bracket-work-lamp-rectangular-and-oval-za1016": {
                  
              }
          }
      },
      "Leopard 85": {
          "1978-1982": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Rubin 120": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Rubin 135": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Rubin 150": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Rubin 160": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Rubin 180": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Rubin 200": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Silver 100.4": {
          "1995-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver 100.6": {
          "1995-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver 110": {
          "2000-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver 130": {
          "2000-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver 160": {
          "2000-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver 180": {
          "2000-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver 80": {
          "1995-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver 90": {
          "1995-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver W100": {
          "2000-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver W105": {
          "2000-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver W85": {
          "2000-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Silver W95": {
          "2000-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Titan 145": {
          "1995-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Titan 150": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Titan 160": {
          "1991-1995": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1995-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Titan 165": {
          "1998-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Titan 190": {
          "1992-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      }
  },
  "Steyr": {
      "1400": {
          "1974-1976": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8045": {
          "1988-1992": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "8055": {
          "1988-1992": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "8060": {
          "1979-1987": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8065": {
          "1988-1992": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8070": {
          "1984-1992": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8075": {
          "1988-1993": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "8080": {
          "1979-1984": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8085": {
          "1988-1993": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "8090": {
          "1983-1992": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8100": {
          "1978-1984": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8110": {
          "1978-1984": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8120": {
          "1978-1984": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8130": {
          "1984-1987": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8140": {
          "1977-1982": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8150": {
          "1982-1993": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8160": {
          "1976-1981": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          },
          "1981-1986": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8165": {
          "1986-1993": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "8180": {
          "1987-1993": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
          }
      },
      "9105": {
          "1995-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "9115": {
          "1995-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "9125": {
          "1995-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "9145": {
          "1995-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "9155": {
          "1993-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "9160": {
          "1995-1997": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
          }
      },
      "9170": {
          "1993-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
          }
      },
      "9180": {
          "1995-1997": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
          }
      },
      "9190": {
          "1993-1995": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
          }
      },
      "9200": {
          "1995-1997": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              },
          }
      },
      "4100 Profi": {
          "2003-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4110 Profi": {
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2012-2016": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4110 ProfiClassic": {
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4110 ProfiCVT": {
          "2013-2016": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4115 Profi": {
          "2003-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2013-2018": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2018-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "4115 ProfiCVT": {
          "2018-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "4120 Profi": {
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2012-2016": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4120 ProfiCVT": {
          "2013-2016": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4125 Profi": {
          "2018-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "4125 ProfiCVT": {
          "2018-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "4130 Profi": {
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2012-2016": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4130 ProfiCVT": {
          "2013-2016": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4135 Profi": {
          "2018-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "4135 ProfiCVT": {
          "2018-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "4145 Profi": {
          "2018-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "4145 ProfiCVT": {
          "2018-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6115 Profi": {
          "2003-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6125 Profi": {
          "2003-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2012-2016": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6125 ProfiClassic": {
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6130CVT": {
          "2011-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6135 Profi": {
          "2003-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6135CVT": {
          "2003-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "6140 Profi": {
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2012-2016": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6140 ProfiClassic": {
          "2007-2012": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6140CVT": {
          "2007-2012": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6145  CVT": {
          "2003-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2011-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6145 Profi": {
          "2018-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6150  CVT": {
          "2007-2012": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2015-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              }
          }
      },
      "6150 Profi  CVT": {
          "2016-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6155  CVT": {
          "2003-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6160  CVT": {
          "2007-2012": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2011-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6165  CVT": {
          "2009-2011": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2015-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6170  CVT": {
          "2003-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2011-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6175  CVT": {
          "2007-2012": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2015-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6180  CVT": {
          "2009-2011": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6185  CVT": {
          "2011-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2015-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6190  CVT": {
          "2003-2005": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6195  CVT": {
          "2005-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2007-2009": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6200  CVT": {
          "2009-2011": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2011-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2015-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6210  CVT": {
          "2009-2011": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6215  CVT": {
          "2011-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6220  CVT": {
          "2015-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6225  CVT": {
          "2009-2011": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6230  CVT": {
          "2011-2015": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "6240  CVT": {
          "2015-2020": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "8055T": {
          "1988-1992": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          },
          "1988-1993": {
              "crawer-led-45w-john-deere-work-light-cr-1028": {
                  
              }
          }
      },
      "9080M": {
          "2003-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "9080MT": {
          "2007-2008": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "9085MT": {
          "2008-2011": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "9090M": {
          "2003-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "9090MT": {
          "2007-2008": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "9095MT": {
          "2008-2011": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "9100M": {
          "2003-2007": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
          }
      },
      "9100MT": {
          "2007-2008": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "9105MT": {
          "2008-2011": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "CVT 120": {
          "2000-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
          }
      },
      "CVT 130": {
          "2000-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
          }
      },
      "CVT 150": {
          "2000-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
          }
      },
      "CVT 170": {
          "2000-2003": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
          }
      },
      "Kompakt 360": {
          "2003-2008": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 370": {
          "2003-2008": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 375": {
          "2003-2008": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 4055S": {
          "2011-2014": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2014-2017": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 4065": {
          "2008-2014": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 4065S": {
          "2011-2014": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2014-2017": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 4075": {
          "2014-2018": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 4085": {
          "2012-2014": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2014-2018": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 4095": {
          "2012-2014": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2014-2017": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 4105": {
          "2012-2014": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2014-2017": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 4115": {
          "2012-2014": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          },
          "2014-2017": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 485": {
          "2005-2008": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "Kompakt 495": {
          "2005-2008": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              }
          }
      },
      "M952": {
          "2001-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "M963": {
          "2001-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "M968": {
          "2001-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "M975": {
          "2001-2004": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-recessed-rectangular-worklight-40w-crw4402": {
                  
              }
          }
      },
      "Multi 4095": {
          "2013-2016": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Multi 4100": {
          "2016-2023": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Multi 4105": {
          "2013-2016": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Multi 4110": {
          "2016-2023": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Multi 4115": {
          "2013-2016": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Multi 4120": {
          "2016-2023": {
              "crawer-45-watt-square-led-worklight-cr-1023": {
                  
              },
              "crawer-50w-round-led-worklight-cr-1041": {
                  
              },
              "crawer-work-lamp-set-40w-for-steyr-crw014": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Terrus 6250CVT": {
          "2017-2023": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
          }
      },
      "Terrus 6270CVT": {
          "2015-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
          }
      },
      "Terrus 6300CVT": {
          "2015-Present": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
          }
      }
  },
  "Ursus": {
      "902": {
          "1983-1985": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "904": {
          "1983-1985": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "912": {
          "1985-1988": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "914": {
          "1984-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "932": {
          "1991-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "934": {
          "1991-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1002": {
          "1981-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1004": {
          "1981-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1014": {
          "1984-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1032": {
          "1983-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1034": {
          "1983-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1132": {
          "1983-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1134": {
          "1983-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1201": {
          "1974-1983": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "1204": {
          "1974-1983": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "1212": {
          "1981-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1214": {
          "1981-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1222": {
          "1981-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1224": {
          "1981-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1232": {
          "1983-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1234": {
          "1983-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1434": {
          "1983-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1614": {
          "1981-1984": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "1634": {
          "1983-1985": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "2812": {
          "1978-2009": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "3514": {
          "1984-2011": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
          }
      },
      "3702": {
          "1983-1985": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "4512": {
          "1984-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5312": {
          "1984-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5314": {
          "1984-2011": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "1993-2009": {
          }
      },
      "3321 Super": {
          "1997-2004": {
          }
      },
      "902 turbo": {
          "1983-1985": {
          }
      },
      "904 turbo": {
          "1983-1985": {
          }
      },
      "C-3110": {
          "2014-2023": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-led-work-lamp-30w-rectangular-wl30e": {
                  
              }
          }
      },
      "C-325": {
          "1981-1984": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "C-328": {
          "1981-1984": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "C-330": {
          "1981-1984": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "C-330M": {
          "1981-1984": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "C-335": {
          "1981-1984": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "C-335M": {
          "1981-1984": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "C-360": {
          "1976-1987": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "C-362": {
          "1980-1987": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      },
      "C-4011": {
          "1965-1970": {
              "crawer-led-work-light-48-watt-wl4048": {
                  
              }
          }
      }
  },
  "Valtra Valmet": {
      "A104": {
          "2017-2020": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
          }
      },
      "A114": {
          "2017-2021": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "A124": {
          "2017-2021": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "A134": {
          "2017-2021": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "A74": {
          "2017-2021": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "A84": {
          "2017-2021": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "A94": {
          "2017-2021": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "C100": {
          "2004-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "C110": {
          "2004-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "C120": {
          "2004-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "C120e": {
          "2004-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "C130": {
          "2004-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "C150": {
          "2004-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "C90": {
          "2004-2006": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "M120": {
          "2004-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "M120e": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "M130": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "M150": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N101": {
          "2005-2006": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2006-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N103": {
          "2012-2016": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N103.4": {
          "2013-2016": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N104": {
          "2015-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "N111": {
          "2005-2006": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N111e": {
          "2005-2006": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2006-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N113": {
          "2011-2016": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N114e": {
          "2015-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "N121": {
          "2005-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N122": {
          "2009-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N123": {
          "2011-2016": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N124": {
          "2015-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "N134": {
          "2015-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              }
          }
      },
      "N141": {
          "2005-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2007-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N142": {
          "2009-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N143": {
          "2011-2016": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N154e": {
          "2015-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "N163": {
          "2011-2016": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N174": {
          "2015-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "N82": {
          "2007-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N91": {
          "2005-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N92": {
          "2007-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "N93": {
          "2012-2016": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S230": {
          "2001-2003": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S232": {
          "2008-2011": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S233": {
          "2011-2013": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S240": {
          "2003-2006": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S260": {
          "2001-2003": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S262": {
          "2008-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S263": {
          "2011-2013": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S274": {
          "2014-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
          }
      },
      "S280": {
          "2003-2008": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S292": {
          "2008-2011": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S293": {
          "2011-2013": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S294": {
          "2014-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
          }
      },
      "S322": {
          "2008-2011": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S323": {
          "2011-2013": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S324": {
          "2014-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
          }
      },
      "S352": {
          "2008-2011": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S353": {
          "2011-2013": {
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "S354": {
          "2014-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              }
          }
      },
      "S374": {
          "2014-2019": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
          }
      },
      "S394": {
          "2017-2021": {
              "crawer-claas-led-bonnet-cab-work-light-cr-1019": {
                  
              },
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
          }
      },
      "T120": {
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              }
          }
      },
      "T120\/c": {
          "2004-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T121": {
          "2007-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T130": {
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              }
          }
      },
      "T130\/c": {
          "2004-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T131": {
          "2007-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T132": {
          "2009-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T133": {
          "2012-2015": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T140": {
          "2002-2004": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              }
          }
      },
      "T140e\/ec": {
          "2004-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T144": {
          "2014-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "T150\/c": {
          "2004-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T151e": {
          "2007-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T152": {
          "2009-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T153": {
          "2012-2015": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T154": {
          "2014-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "T160": {
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              }
          }
      },
      "T160\/c": {
          "2004-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T161": {
          "2007-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T162e": {
          "2009-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T163e": {
          "2012-2014": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T170": {
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              }
          }
      },
      "T170\/c": {
          "2004-2006": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2006-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T171": {
          "2007-1012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T172": {
          "2009-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T173": {
          "2012-2015": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T174": {
          "2014-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "T180": {
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              }
          },
          "2004-2006": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T182": {
          "2009-2011": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T183": {
          "2012-2014": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T190": {
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              }
          },
          "2004-2006": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2006-2007": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T191": {
          "2007-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T193": {
          "2012-2015": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T194": {
          "2014-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "T202": {
          "2009-2012": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T203": {
          "2012-2014": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T213": {
          "2012-2014": {
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "T214": {
          "2014-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "T234": {
          "2014-Present": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "T254": {
          "2017-2021": {
              "crawer-led-work-light-50w-round-valtra-cr-1025": {
                  
              },
              "crawer-adapter-cable-h9-to-9005-za2021": {
                  
              }
          }
      },
      "Valmet505": {
          "1983-1984": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1984-1989": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet600": {
          "1997-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6000": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet605": {
          "1983-1984": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1984-1989": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6100": {
          "1991-1994": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6200": {
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2004-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6250HI": {
          "2004-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6300": {
          "1991-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2003-2007": {
          }
      },
      "Valmet6350": {
          "1998-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6350HI": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6400": {
          "1991-1994": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1994-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2000-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2003-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6550HI": {
          "2003-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6600": {
          "1991-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1993-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6650": {
          "1998-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6750": {
          "2002-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6800": {
          "1996-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6850": {
          "1998-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6850HI": {
          "2004-2006": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet6900": {
          "1997-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet700": {
          "1997-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet705": {
          "1983-1989": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet705PowerPlus": {
          "1989-1991": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet755PowerPlus": {
          "1989-1991": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet800": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2001-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8000": {
          "1991-1994": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "1994-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Valmet805": {
          "1983-1989": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8050": {
          "1995-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Valmet8050HI": {
          "1998-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8100": {
          "1990-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Valmet8100TS": {
          "1992-1993": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8150": {
          "1995-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Valmet8150HI": {
          "1998-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2003-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8200": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8300": {
          "1990-1992": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8350": {
          "1998-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8350HI": {
          "1998-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8400": {
          "1993-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "1996-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2000-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2002-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Valmet8450": {
          "1995-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8450HI": {
          "1998-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8550": {
          "1995-2001": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8550HI": {
          "1998-2003": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8600": {
          "1990-1994": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8750": {
          "1995-2000": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8800": {
          "1994-1996": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8850": {
          "1997-1998": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-led-work-light-set-built-in-fendt-40w-cr-1062s": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet8950HI": {
          "1998-2002": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet900": {
          "1997-2001": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          },
          "2001-2002": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet905": {
          "1984-1989": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "Valmet905PowerPlus": {
          "1989-1991": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              },
          }
      },
      "XM130": {
          "2003-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "XM150": {
          "2003-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutz-valtra-built-in-led-work-light-cr-1013": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      }
  },
  "Zetor": {
      "3321 Super": {
          "1997-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "3341 Super": {
          "1997-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4321 Super": {
          "1997-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "4341 Super ": {
          "1997-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5321 Super": {
          "1997-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "5341 Super": {
          "1997-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6321 Super": {
          "1997-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "6341 Super": {
          "1997-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7321 Super": {
          "1997-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "7341 Super": {
          "1997-2004": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Crystal HD 170": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra 105": {
          "2010-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra 10641": {
          "1999-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra 11441": {
          "2002-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra 115": {
          "2010-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra 11641": {
          "2002-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra 11741": {
          "2006-2008": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra 125": {
          "2010-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra 135": {
          "2010-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra 8641": {
          "1999-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra 95": {
          "2010-2014": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra 9641": {
          "1999-2009": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-square-led-45w-work-light-for-fendt-cr-1022": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra CL 100": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra CL 110": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra CL 120": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra CL 130": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra CL 140": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra HD 130": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra HD 140": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra HD 150": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra HSX 100": {
          "2012-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra HSX 110": {
          "2012-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Forterra HSX 120": {
          "2012-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra HSX 130": {
          "2012-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Forterra HSX 140": {
          "2012-2018": {
              "crawer-50-watt-oval-led-worklight-spot-beam-cr-1035": {
                  
              },
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          },
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Hortus CL65": {
          "2018-2024": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Hortus HS65": {
          "2018-2024": {
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Major 80CL": {
          "2018-2024": {
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Proxima 6421": {
          "2004-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Proxima 6441": {
          "2004-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Proxima 7421": {
          "2004-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Proxima 7441": {
          "2004-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Proxima 8441": {
          "2004-2007": {
              "crawer-led-spot-beam-work-lamp-50w-rectangle-40-degrees-cr-1004": {
                  
              },
              "crawer-led-flood-beam-work-lamp-50w-rectangle-60-degrees-cr-1005": {
                  
              },
              "crawer-deutsch-female-connector-dtsch2p-f": {
                  
              }
          }
      },
      "Proxima CL 100": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima CL 110": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima CL 80": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima CL 90": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima GP 100": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima GP 110": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima GP 80": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima GP 90": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima HS 100": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima HS 110": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima HS 120": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima HS 80": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      },
      "Proxima HS 90": {
          "2018-2024": {
              "crawer-john-deere-40w-led-bonnet-work-light-crw012": {
                  
              },
              "crawer-30w-led-round-work-light-cree-crw-3030": {
                  
              }
          }
      }
  }
}